(() => {
  if (window.__claywallCheckoutLoaded) return;
  window.__claywallCheckoutLoaded = true;

  let nativeCheckoutAllowed = false;
  let checkoutButton = null;

  let quoteTimer = null;
  let quoteRequestId = 0;

  let addressSuggestTimer = null;
let addressSuggestController = null;
let addressResolveController = null;


let billingAddressSuggestTimer = null;
let billingAddressSuggestController = null;
let billingAddressResolveController = null;

let companyLookupTimer = null;
let companyLookupController = null;

  function dialog() {
    return document.getElementById(
      'claywall-delivery-dialog'
    );
  }

  function methodStep() {
    return dialog()?.querySelector(
      '[data-claywall-method-step]'
    );
  }

  function addressStep() {
    return dialog()?.querySelector(
      '[data-claywall-address-step]'
    );
  }

  function form() {
    return dialog()?.querySelector(
      '[data-claywall-checkout-form]'
    );
  }

  function formatPrice(value) {
    return new Intl.NumberFormat(
      'cs-CZ',
      {
        style: 'currency',
        currency: 'CZK'
      }
    ).format(value);
  }

  function normalizeZip(value) {
    return String(value || '')
      .replace(/\D/g, '');
  }

  function formatZip(value) {
    const digits = normalizeZip(value);

    if (digits.length <= 3) {
      return digits;
    }

    return (
      digits.slice(0, 3) +
      ' ' +
      digits.slice(3, 5)
    );
  }

 function showMethods() {
  const methods = methodStep();
  const address = addressStep();
  const el = dialog();

  if (methods) {
    methods.hidden = false;
  }

  if (address) {
    address.hidden = true;
  }

  if (el) {
    el.classList.add(
      "is-method-step"
    );

    el.classList.remove(
      "is-address-step"
    );
  }
}

function showAddress() {
  const methods = methodStep();
  const address = addressStep();
  const el = dialog();

  if (methods) {
    methods.hidden = true;
  }

  if (address) {
    address.hidden = false;
  }

  if (el) {
    el.classList.remove(
      "is-method-step"
    );

    el.classList.add(
      "is-address-step"
    );
  }
}

  function closeDialog() {
    const el = dialog();

    if (el?.open) {
      el.close();
    }

    showMethods();
  }

  function getQuoteElements() {
    const currentForm = form();

    if (!currentForm) return {};

    return {
      price:
        currentForm.querySelector(
          '[data-claywall-shipping-price]'
        ),

      note:
        currentForm.querySelector(
          '[data-claywall-shipping-note]'
        ),

      summary:
        currentForm.querySelector(
          '[data-claywall-shipping-summary]'
        ),

      submit:
        currentForm.querySelector(
          '[data-claywall-submit]'
        ),

      error:
        currentForm.querySelector(
          '[data-claywall-error]'
        )
    };
  }

  function invalidateQuote() {
    quoteRequestId++;

    const {
      price,
      note,
      summary,
      submit
    } = getQuoteElements();

    if (price) {
      price.textContent = '—';
    }

    if (note) {
      note.textContent =
        'Vyplňte PSČ a město';
    }

    if (summary) {
      summary.classList.remove(
        'is-loading',
        'is-success'
      );
    }

    if (submit) {
      submit.disabled = true;
    }
  }


  function getAddressElements(currentForm) {
  if (!currentForm) {
    return {};
  }

  return {
    addressInput:
      currentForm.querySelector(
        '[data-claywall-address-search]'
      ),

    suggestions:
      currentForm.querySelector(
        '[data-claywall-address-suggestions]'
      ),

    verified:
      currentForm.querySelector(
        '[data-claywall-address-verified]'
      ),

    ruianId:
      currentForm.querySelector(
        '[name="shipping_ruian_id"]'
      ),

    ruianCode:
      currentForm.querySelector(
        '[name="shipping_ruian_code"]'
      ),

    zip:
      currentForm.querySelector(
        '[name="zip"]'
      ),

    city:
      currentForm.querySelector(
        '[name="city"]'
      )
  };
}


function clearAddressSuggestions(
  currentForm
) {
  const {
    suggestions
  } =
    getAddressElements(
      currentForm
    );

  if (!suggestions) {
    return;
  }

  suggestions.innerHTML = "";
  suggestions.hidden = true;
}


function invalidateVerifiedAddress(
  currentForm
) {
  const {
    verified,
    ruianId,
    ruianCode,
    zip,
    city
  } =
    getAddressElements(
      currentForm
    );

  if (ruianId) {
    ruianId.value = "";
  }

  if (ruianCode) {
    ruianCode.value = "";
  }

  if (verified) {
    verified.hidden = true;
  }

  if (zip) {
    zip.readOnly = false;
    zip.value = "";
  }

  if (city) {
    city.readOnly = false;
    city.value = "";
  }

  invalidateQuote();
}


async function loadAddressSuggestions(
  currentForm,
  query
) {
  const {
    suggestions
  } =
    getAddressElements(
      currentForm
    );

  if (!suggestions) {
    return;
  }

  if (
    addressSuggestController
  ) {
    addressSuggestController.abort();
  }

  addressSuggestController =
    new AbortController();

  try {
    const shopRoot =
      window.Shopify?.routes?.root ||
      "/";

    const response =
      await fetch(
        shopRoot +
          "apps/claywall-shipping/address-suggest?q=" +
          encodeURIComponent(query),
        {
          credentials:
            "same-origin",

          cache:
            "no-store",

          signal:
            addressSuggestController.signal
        }
      );

    const result =
      await response.json();

    if (
      !response.ok ||
      result.status !== "ok"
    ) {
      throw new Error(
        result.message ||
        "Adresy se nepodařilo načíst."
      );
    }

    suggestions.innerHTML = "";

    const results =
      Array.isArray(
        result.suggestions
      )
        ? result.suggestions
        : [];

    if (
      results.length === 0
    ) {
      suggestions.hidden = true;
      return;
    }

    for (
      const suggestion
      of results
    ) {
      const button =
        document.createElement(
          "button"
        );

      button.type = "button";

      button.className =
        "claywall-address-suggestion";

      button.dataset.claywallAddressSuggestion =
        suggestion.id;

      button.textContent =
        suggestion.text;

      suggestions.appendChild(
        button
      );
    }

    suggestions.hidden = false;

  } catch (errorObject) {
    if (
      errorObject.name ===
      "AbortError"
    ) {
      return;
    }

    console.error(
      "CLAYWALL RUIAN suggest:",
      errorObject
    );

    clearAddressSuggestions(
      currentForm
    );
  }
}


async function resolveAddress(
  currentForm,
  objectId
) {
  const {
    addressInput,
    suggestions,
    verified,
    ruianId,
    ruianCode,
    zip,
    city
  } =
    getAddressElements(
      currentForm
    );

  if (
    addressResolveController
  ) {
    addressResolveController.abort();
  }

  addressResolveController =
    new AbortController();

  if (suggestions) {
    suggestions.hidden = true;
  }

  try {
    const shopRoot =
      window.Shopify?.routes?.root ||
      "/";

    const response =
      await fetch(
        shopRoot +
          "apps/claywall-shipping/address-resolve?id=" +
          encodeURIComponent(
            objectId
          ),
        {
          credentials:
            "same-origin",

          cache:
            "no-store",

          signal:
            addressResolveController.signal
        }
      );

    const result =
      await response.json();

    if (
      !response.ok ||
      result.status !== "ok" ||
      result.verified !== true ||
      !result.address
    ) {
      throw new Error(
        result.message ||
        "Adresu se nepodařilo ověřit."
      );
    }

    const address =
      result.address;

    if (addressInput) {
      addressInput.value =
        address.address1 || "";
    }

    if (zip) {
      zip.value =
        formatZip(
          address.zip || ""
        );

      zip.readOnly = true;
    }

    if (city) {
      city.value =
        address.city || "";

      city.readOnly = true;
    }

    if (ruianId) {
      ruianId.value =
        address.ruianObjectId ||
        objectId;
    }

    if (ruianCode) {
      ruianCode.value =
        address.ruianCode || "";
    }

    if (verified) {
      verified.hidden = false;
    }

    clearAddressSuggestions(
      currentForm
    );

    /*
      RUIAN nam prave doplnil
      PSC + mesto.

      Muzeme rovnou spocitat
      TOPTRANS.
    */
    scheduleQuote();

  } catch (errorObject) {
    if (
      errorObject.name ===
      "AbortError"
    ) {
      return;
    }

    console.error(
      "CLAYWALL RUIAN resolve:",
      errorObject
    );

    invalidateVerifiedAddress(
      currentForm
    );
  }
}

function getBillingAddressElements(currentForm) {
  if (!currentForm) {
    return {};
  }

  return {
    addressInput:
      currentForm.querySelector(
        '[data-claywall-billing-address-search]'
      ),

    suggestions:
      currentForm.querySelector(
        '[data-claywall-billing-address-suggestions]'
      ),

    verified:
      currentForm.querySelector(
        '[data-claywall-billing-address-verified]'
      ),

    ruianId:
      currentForm.querySelector(
        '[name="billing_ruian_id"]'
      ),

    ruianCode:
      currentForm.querySelector(
        '[name="billing_ruian_code"]'
      ),

    zip:
      currentForm.querySelector(
        '[name="billing_zip"]'
      ),

    city:
      currentForm.querySelector(
        '[name="billing_city"]'
      )
  };
}


function clearBillingAddressSuggestions(
  currentForm
) {
  const {
    suggestions
  } =
    getBillingAddressElements(
      currentForm
    );

  if (!suggestions) {
    return;
  }

  suggestions.innerHTML = "";
  suggestions.hidden = true;
}


function invalidateVerifiedBillingAddress(
  currentForm
) {
  const {
    verified,
    ruianId,
    ruianCode,
    zip,
    city
  } =
    getBillingAddressElements(
      currentForm
    );

  if (ruianId) {
    ruianId.value = "";
  }

  if (ruianCode) {
    ruianCode.value = "";
  }

  if (verified) {
    verified.hidden = true;
  }

  if (zip) {
    zip.readOnly = false;
    zip.value = "";
  }

  if (city) {
    city.readOnly = false;
    city.value = "";
  }
}


async function loadBillingAddressSuggestions(
  currentForm,
  query
) {
  const {
    suggestions
  } =
    getBillingAddressElements(
      currentForm
    );

  if (!suggestions) {
    return;
  }

  if (
    billingAddressSuggestController
  ) {
    billingAddressSuggestController.abort();
  }

  billingAddressSuggestController =
    new AbortController();

  try {
    const shopRoot =
      window.Shopify?.routes?.root ||
      "/";

    const response =
      await fetch(
        shopRoot +
          "apps/claywall-shipping/address-suggest?q=" +
          encodeURIComponent(query),
        {
          credentials:
            "same-origin",

          cache:
            "no-store",

          signal:
            billingAddressSuggestController.signal
        }
      );

    const result =
      await response.json();

    if (
      !response.ok ||
      result.status !== "ok"
    ) {
      throw new Error(
        result.message ||
        "Fakturační adresy se nepodařilo načíst."
      );
    }

    suggestions.innerHTML = "";

    const results =
      Array.isArray(
        result.suggestions
      )
        ? result.suggestions
        : [];

    if (
      results.length === 0
    ) {
      suggestions.hidden = true;
      return;
    }

    for (
      const suggestion
      of results
    ) {
      const button =
        document.createElement(
          "button"
        );

      button.type = "button";

      button.className =
        "claywall-address-suggestion";

      button.dataset.claywallBillingAddressSuggestion =
        suggestion.id;

      button.textContent =
        suggestion.text;

      suggestions.appendChild(
        button
      );
    }

    suggestions.hidden = false;

  } catch (errorObject) {
    if (
      errorObject.name ===
      "AbortError"
    ) {
      return;
    }

    console.error(
      "CLAYWALL billing RUIAN suggest:",
      errorObject
    );

    clearBillingAddressSuggestions(
      currentForm
    );
  }
}


async function resolveBillingAddress(
  currentForm,
  objectId
) {
  const {
    addressInput,
    suggestions,
    verified,
    ruianId,
    ruianCode,
    zip,
    city
  } =
    getBillingAddressElements(
      currentForm
    );

  if (
    billingAddressResolveController
  ) {
    billingAddressResolveController.abort();
  }

  billingAddressResolveController =
    new AbortController();

  if (suggestions) {
    suggestions.hidden = true;
  }

  try {
    const shopRoot =
      window.Shopify?.routes?.root ||
      "/";

    const response =
      await fetch(
        shopRoot +
          "apps/claywall-shipping/address-resolve?id=" +
          encodeURIComponent(
            objectId
          ),
        {
          credentials:
            "same-origin",

          cache:
            "no-store",

          signal:
            billingAddressResolveController.signal
        }
      );

    const result =
      await response.json();

    if (
      !response.ok ||
      result.status !== "ok" ||
      result.verified !== true ||
      !result.address
    ) {
      throw new Error(
        result.message ||
        "Fakturační adresu se nepodařilo ověřit."
      );
    }

    const address =
      result.address;

    if (addressInput) {
      addressInput.value =
        address.address1 || "";
    }

    if (zip) {
      zip.value =
        formatZip(
          address.zip || ""
        );

      zip.readOnly = true;
    }

    if (city) {
      city.value =
        address.city || "";

      city.readOnly = true;
    }

    if (ruianId) {
      ruianId.value =
        address.ruianObjectId ||
        objectId;
    }

    if (ruianCode) {
      ruianCode.value =
        address.ruianCode || "";
    }

    if (verified) {
      verified.hidden = false;
    }

    clearBillingAddressSuggestions(
      currentForm
    );

  } catch (errorObject) {
    if (
      errorObject.name ===
      "AbortError"
    ) {
      return;
    }

    console.error(
      "CLAYWALL billing RUIAN resolve:",
      errorObject
    );

    invalidateVerifiedBillingAddress(
      currentForm
    );
  }
}



  async function loadCart() {
    const shopRoot =
      window.Shopify?.routes?.root || '/';

    const response =
      await fetch(
        shopRoot + 'cart.js',
        {
          credentials: 'same-origin',
          cache: 'no-store'
        }
      );

    if (!response.ok) {
      throw new Error(
        'Nepodařilo se načíst košík.'
      );
    }

    const cart =
      await response.json();

    if (!cart.items?.length) {
      throw new Error(
        'Košík je prázdný.'
      );
    }

    return cart;
  }

  async function calculateQuote() {
    const currentForm = form();

    if (!currentForm) return;

    const zipInput =
      currentForm.querySelector(
        '[name="zip"]'
      );

    const cityInput =
      currentForm.querySelector(
        '[name="city"]'
      );

    const zip =
      normalizeZip(
        zipInput?.value
      );

    const city =
      String(
        cityInput?.value || ''
      ).trim();

    const {
      price,
      note,
      summary,
      submit,
      error
    } = getQuoteElements();

    if (
      !/^\d{5}$/.test(zip) ||
      city.length < 2
    ) {
      invalidateQuote();
      return;
    }

    const currentRequestId =
      ++quoteRequestId;

    if (summary) {
      summary.classList.remove(
        'is-success'
      );

      summary.classList.add(
        'is-loading'
      );
    }

    if (price) {
      price.textContent = 'Počítám…';
    }

    if (note) {
      note.textContent =
        'Načítám aktuální cenu';
    }

    if (submit) {
      submit.disabled = true;
    }

    if (error) {
      error.textContent = '';
    }

    try {
      const cart =
        await loadCart();

      const shopRoot =
        window.Shopify?.routes?.root ||
        '/';

      const response =
        await fetch(
          shopRoot +
            'apps/claywall-shipping/quote',
          {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/json'
            },

            body:
              JSON.stringify({
                destination: {
                  city,
                  zip
                },

                items:
                  cart.items.map(
                    item => ({
                      variant_id:
                        item.variant_id,

                      quantity:
                        item.quantity
                    })
                  )
              })
          }
        );

      const result =
        await response.json();

      /*
       * Ignorujeme starsi odpoved,
       * pokud mezitim uzivatel adresu
       * zmenil.
       */
      if (
        currentRequestId !==
        quoteRequestId
      ) {
        return;
      }

      if (
        !response.ok ||
        result.status !== 'ok'
      ) {
        throw new Error(
          result.message ||
          'Cenu dopravy se nepodařilo vypočítat.'
        );
      }

      if (price) {
        price.textContent =
          formatPrice(
            result.pricing.total_gross
          );
      }

      if (note) {
        note.textContent =
          'Cena včetně DPH';
      }

      if (summary) {
        summary.classList.remove(
          'is-loading'
        );

        summary.classList.add(
          'is-success'
        );
      }

      if (submit) {
        submit.disabled = false;
      }

    } catch (errorObject) {
      if (
        currentRequestId !==
        quoteRequestId
      ) {
        return;
      }

      console.error(
        'CLAYWALL quote:',
        errorObject
      );

      if (price) {
        price.textContent = '—';
      }

      if (note) {
        note.textContent =
          'Cenu se nepodařilo načíst';
      }

      if (summary) {
        summary.classList.remove(
          'is-loading',
          'is-success'
        );
      }

      if (submit) {
        submit.disabled = true;
      }

      if (error) {
        error.textContent =
          errorObject.message ||
          'Cenu dopravy se nepodařilo vypočítat.';
      }
    }
  }

  function scheduleQuote() {
    clearTimeout(quoteTimer);

    invalidateQuote();

    quoteTimer =
      setTimeout(
        calculateQuote,
        650
      );
  }

  /*
   * Zachyceni nativniho checkout
   * tlacitka i v dynamickem cart draweru.
   */
  document.addEventListener(
    'click',
    event => {
      const button =
        event.target.closest(
          '[name="checkout"]'
        );

      if (!button) return;

      if (nativeCheckoutAllowed) {
        nativeCheckoutAllowed = false;
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      checkoutButton = button;

      const el = dialog();

      if (!el) {
        console.error(
          'CLAYWALL delivery dialog nebyl nalezen.'
        );

        return;
      }

      showMethods();
      el.showModal();
    },
    true
  );

  document.addEventListener(
    'click',
    event => {

      if (
        event.target.closest(
          '[data-claywall-close]'
        )
      ) {
        closeDialog();
        return;
      }

      if (
        event.target.closest(
          '[data-claywall-back]'
        )
      ) {
        showMethods();
        return;
      }

      if (
        event.target.closest(
          '[data-claywall-toptrans]'
        )
      ) {
        showAddress();
        return;
      }

      /*
       * Osobni odber nechavame
       * Shopify nativne.
       */
      if (
        event.target.closest(
          '[data-claywall-pickup]'
        )
      ) {
        closeDialog();

        if (!checkoutButton) {
          return;
        }

        nativeCheckoutAllowed = true;
        checkoutButton.click();
      }
    }
  );

  /*
   * Automaticky prepocet dopravy
   * pri zmene PSC nebo mesta.
   */
  document.addEventListener(
    'input',
    event => {
      const field =
        event.target.closest(
          '[data-claywall-quote-field]'
        );

      if (!field) return;

      if (field.name === 'zip') {
        const formatted =
          formatZip(field.value);

        if (
          field.value !== formatted
        ) {
          field.value = formatted;
        }
      }

      scheduleQuote();
    }
  );

  /*
 * Fakturacni adresa.
 */
document.addEventListener(
  "change",
  event => {
    const toggle =
      event.target.closest(
        "[data-claywall-billing-toggle]"
      );

    if (!toggle) return;

    const currentForm =
      toggle.closest(
        "[data-claywall-checkout-form]"
      );

    if (!currentForm) return;

    const section =
      currentForm.querySelector(
        "[data-claywall-billing-section]"
      );

    if (!section) return;

    section.hidden =
      !toggle.checked;

    const requiredFields = [
      "billing_address1",
      "billing_zip",
      "billing_city"
    ];

    for (
      const fieldName
      of requiredFields
    ) {
      const field =
        currentForm.elements[
          fieldName
        ];

      if (field) {
        field.required =
          toggle.checked;
      }
    }

    /*
     * Pokud checkbox zaskrtl
     * primo zakaznik, jemne ho
     * posuneme k nove zobrazene
     * fakturacni adrese.
     *
     * Programove zapnuti pres ARES
     * scroll nespousti.
     */
    if (
      toggle.checked &&
      event.isTrusted
    ) {
      requestAnimationFrame(
        () => {
          section.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }
      );
    }
  }
);

/*
 * Pocitadlo poznamky.
 */
document.addEventListener(
  'input',
  event => {
    const note =
      event.target.closest(
        '[data-claywall-order-note]'
      );

    if (!note) return;

    const currentForm =
      note.closest(
        '[data-claywall-checkout-form]'
      );

    const counter =
      currentForm?.querySelector(
        '[data-claywall-note-count]'
      );

    if (counter) {
      counter.textContent =
        String(note.value.length);
    }
  }
);



  /*
 * RUIAN naseptavani
 * dorucovaci adresy.
 */
document.addEventListener(
  "input",
  event => {
    const addressInput =
      event.target.closest(
        "[data-claywall-address-search]"
      );

    if (!addressInput) {
      return;
    }

    const currentForm =
      addressInput.closest(
        "[data-claywall-checkout-form]"
      );

    if (!currentForm) {
      return;
    }

    /*
      Jakmile zakaznik zacne
      adresu znovu menit,
      puvodni RUIAN overeni
      prestava platit.
    */
    invalidateVerifiedAddress(
      currentForm
    );

    clearTimeout(
      addressSuggestTimer
    );

    const query =
      String(
        addressInput.value || ""
      ).trim();

    if (query.length < 3) {
      clearAddressSuggestions(
        currentForm
      );

      return;
    }

    addressSuggestTimer =
      setTimeout(
        () => {
          loadAddressSuggestions(
            currentForm,
            query
          );
        },
        350
      );
  }
);

  /*
 * Vyber RUIAN adresy.
 */
document.addEventListener(
  "click",
  event => {
    const suggestion =
      event.target.closest(
        "[data-claywall-address-suggestion]"
      );

    if (suggestion) {
      const currentForm =
        suggestion.closest(
          "[data-claywall-checkout-form]"
        );

      if (!currentForm) {
        return;
      }

      const objectId =
        suggestion.dataset
          .claywallAddressSuggestion;

      resolveAddress(
        currentForm,
        objectId
      );

      return;
    }

    /*
      Rucni zmena jiz
      overene adresy.
    */
    const changeButton =
      event.target.closest(
        "[data-claywall-address-change]"
      );

    if (changeButton) {
      const currentForm =
        changeButton.closest(
          "[data-claywall-checkout-form]"
        );

      if (!currentForm) {
        return;
      }

      const {
        addressInput
      } =
        getAddressElements(
          currentForm
        );

      invalidateVerifiedAddress(
        currentForm
      );

      if (addressInput) {
        addressInput.focus();
        addressInput.select();
      }

      return;
    }

    /*
      Kliknuti mimo dropdown.
    */
    if (
      !event.target.closest(
        "[data-claywall-address-autocomplete]"
      )
    ) {
      const currentForm =
        form();

      if (currentForm) {
        clearAddressSuggestions(
          currentForm
        );
      }
    }
  }
);

/*
 * RUIAN naseptavani
 * fakturacni adresy.
 */
document.addEventListener(
  "input",
  event => {
    const addressInput =
      event.target.closest(
        "[data-claywall-billing-address-search]"
      );

    if (!addressInput) {
      return;
    }

    const currentForm =
      addressInput.closest(
        "[data-claywall-checkout-form]"
      );

    if (!currentForm) {
      return;
    }

    invalidateVerifiedBillingAddress(
      currentForm
    );

    clearTimeout(
      billingAddressSuggestTimer
    );

    const query =
      String(
        addressInput.value || ""
      ).trim();

    if (query.length < 3) {
      clearBillingAddressSuggestions(
        currentForm
      );

      return;
    }

    billingAddressSuggestTimer =
      setTimeout(
        () => {
          loadBillingAddressSuggestions(
            currentForm,
            query
          );
        },
        350
      );
  }
);

/*
 * Vyber RUIAN fakturacni adresy.
 */
document.addEventListener(
  "click",
  event => {
    const suggestion =
      event.target.closest(
        "[data-claywall-billing-address-suggestion]"
      );

    if (suggestion) {
      const currentForm =
        suggestion.closest(
          "[data-claywall-checkout-form]"
        );

      if (!currentForm) {
        return;
      }

      const objectId =
        suggestion.dataset
          .claywallBillingAddressSuggestion;

      resolveBillingAddress(
        currentForm,
        objectId
      );

      return;
    }

    const changeButton =
      event.target.closest(
        "[data-claywall-billing-address-change]"
      );

    if (changeButton) {
      const currentForm =
        changeButton.closest(
          "[data-claywall-checkout-form]"
        );

      if (!currentForm) {
        return;
      }

      const {
        addressInput
      } =
        getBillingAddressElements(
          currentForm
        );

      invalidateVerifiedBillingAddress(
        currentForm
      );

      if (addressInput) {
        addressInput.focus();
        addressInput.select();
      }

      return;
    }

    if (
      !event.target.closest(
        "[data-claywall-billing-address-autocomplete]"
      )
    ) {
      const currentForm =
        form();

      if (currentForm) {
        clearBillingAddressSuggestions(
          currentForm
        );
      }
    }
  }
);

/*
 * Soukroma osoba / Firma
 */
document.addEventListener(
  "click",
  event => {
    const button =
      event.target.closest(
        "[data-claywall-customer-type]"
      );

    if (!button) {
      return;
    }

    const currentForm =
      button.closest(
        "[data-claywall-checkout-form]"
      );

    if (!currentForm) {
      return;
    }

    const type =
      button.dataset
        .claywallCustomerType;

    const typeInput =
      currentForm.querySelector(
        "[data-claywall-customer-type-input]"
      );

    const companyFields =
      currentForm.querySelector(
        "[data-claywall-company-fields]"
      );

    const companyName =
      currentForm.elements[
        "company_name"
      ];

    const companyId =
      currentForm.elements[
        "company_id"
      ];

    /*
      Prepneme aktivni tlacitko.
    */
    currentForm
      .querySelectorAll(
        "[data-claywall-customer-type]"
      )
      .forEach(option => {
        const active =
          option.dataset
            .claywallCustomerType ===
          type;

        option.classList.toggle(
          "is-active",
          active
        );

        option.setAttribute(
          "aria-pressed",
          active
            ? "true"
            : "false"
        );
      });

    if (typeInput) {
      typeInput.value = type;
    }

    const isCompany =
      type === "company";

    if (companyFields) {
      companyFields.hidden =
        !isCompany;
    }

    /*
      U firmy je povinny
      nazev a ICO.
      DIC nechavame volitelne.
    */
    if (companyName) {
      companyName.required =
        isCompany;
    }

    if (companyId) {
      companyId.required =
        isCompany;
    }

    if (isCompany) {
      companyName?.focus();
    }
  }
);

function invalidateVerifiedCompany(
  currentForm
) {
  if (!currentForm) return;

  const verified =
    currentForm.querySelector(
      "[data-claywall-company-verified]"
    );

  const status =
    currentForm.querySelector(
      "[data-claywall-company-status]"
    );

  if (verified) {
    verified.hidden = true;
  }

  if (status) {
    status.textContent = "";
  }
}


async function resolveCompanyByIco(
  currentForm,
  ico
) {
  if (
    companyLookupController
  ) {
    companyLookupController.abort();
  }

  companyLookupController =
    new AbortController();

  const nameInput =
    currentForm.elements[
      "company_name"
    ];

  const vatInput =
    currentForm.elements[
      "company_vat_id"
    ];

  const icoInput =
    currentForm.elements[
      "company_id"
    ];

  const verified =
    currentForm.querySelector(
      "[data-claywall-company-verified]"
    );

  const seat =
    currentForm.querySelector(
      "[data-claywall-company-seat]"
    );

  const status =
    currentForm.querySelector(
      "[data-claywall-company-status]"
    );

  const companyBilling =
    currentForm.querySelector(
      "[data-claywall-company-billing]"
    );

  const companySeatAddress1 =
    currentForm.querySelector(
      "[data-claywall-company-seat-address1]"
    );

  const companySeatZip =
    currentForm.querySelector(
      "[data-claywall-company-seat-zip]"
    );

  const companySeatCity =
    currentForm.querySelector(
      "[data-claywall-company-seat-city]"
    );

  const companySeatRuianCode =
    currentForm.querySelector(
      "[data-claywall-company-seat-ruian-code]"
    );

  if (status) {
    status.textContent =
      "Ověřuji firmu v ARES…";
  }

  try {
    const shopRoot =
      window.Shopify?.routes?.root ||
      "/";

    const response =
      await fetch(
        shopRoot +
          "apps/claywall-shipping/company-resolve?ico=" +
          encodeURIComponent(ico),
        {
          credentials:
            "same-origin",

          cache:
            "no-store",

          signal:
            companyLookupController.signal
        }
      );

    const result =
      await response.json();

    if (
      !response.ok ||
      result.status !== "ok" ||
      result.verified !== true ||
      !result.company
    ) {
      throw new Error(
        result.message ||
        "Firmu se nepodařilo ověřit."
      );
    }

    const company =
      result.company;

    if (!company.active) {
      throw new Error(
        "Tento subjekt již není aktivní."
      );
    }

    const seatAddress1 =
      String(
        company.seat?.fullAddress || ""
      )
        .split(",")[0]
        .trim();

    const seatZip =
      String(
        company.seat?.zip || ""
      ).replace(/\D/g, "");

    const seatCity =
      String(
        company.seat?.city || ""
      ).trim();

    const seatRuianCode =
      String(
        company.seat?.ruianCode || ""
      ).trim();

    /*
      Zakladni firemni udaje.
    */
    if (icoInput) {
      icoInput.value =
        company.ico || ico;
    }

    if (nameInput) {
      nameInput.value =
        company.name || "";
    }

    if (vatInput) {
      vatInput.value =
        company.dic || "";
    }

    if (seat) {
      seat.textContent =
        company.seat?.fullAddress || "";
    }

    /*
      Sídlo firmy ulozime
      do pomocnych poli.
    */
    if (companySeatAddress1) {
      companySeatAddress1.value =
        seatAddress1;
    }

    if (companySeatZip) {
      companySeatZip.value =
        seatZip;
    }

    if (companySeatCity) {
      companySeatCity.value =
        seatCity;
    }

    if (companySeatRuianCode) {
      companySeatRuianCode.value =
        seatRuianCode;
    }

    /*
      Zobrazime overeni firmy.
    */
    if (verified) {
      verified.hidden = false;
    }

    /*
      Checkbox sidla zobrazime
      jen pokud ARES vratil
      pouzitelnou adresu.
    */
    if (
      companyBilling &&
      seatAddress1 &&
      /^\d{5}$/.test(seatZip) &&
      seatCity.length >= 2
    ) {
      companyBilling.hidden = false;
    }

    if (status) {
      status.textContent = "";
    }

    /*
      Po overeni ICO uzamkneme.
    */
    if (icoInput) {
      icoInput.readOnly = true;
    }

  } catch (errorObject) {
    if (
      errorObject.name ===
      "AbortError"
    ) {
      return;
    }

    console.error(
      "CLAYWALL ARES:",
      errorObject
    );

    if (verified) {
      verified.hidden = true;
    }

    if (companyBilling) {
      companyBilling.hidden = true;
    }

    if (status) {
      status.textContent =
        errorObject.message ||
        "Firmu se nepodařilo ověřit.";
    }
  }
}
/*
 * Automaticke overeni ICO.
 */
document.addEventListener(
  "input",
  event => {
    const icoInput =
      event.target.closest(
        '[name="company_id"]'
      );

    if (!icoInput) return;

    const currentForm =
      icoInput.closest(
        "[data-claywall-checkout-form]"
      );

    if (!currentForm) return;

    invalidateVerifiedCompany(
      currentForm
    );

    clearTimeout(
      companyLookupTimer
    );

    const ico =
      String(
        icoInput.value || ""
      ).replace(/\D/g, "");

    icoInput.value = ico;

    if (ico.length !== 8) {
      return;
    }

    companyLookupTimer =
      setTimeout(
        () => {
          resolveCompanyByIco(
            currentForm,
            ico
          );
        },
        400
      );
  }
);


/*
 * Zmena jiz overeneho ICO.
 */
document.addEventListener(
  "click",
  event => {
    const button =
      event.target.closest(
        "[data-claywall-company-change]"
      );

    if (!button) return;

    const currentForm =
      button.closest(
        "[data-claywall-checkout-form]"
      );

    if (!currentForm) return;


    const icoInput =
      currentForm.elements[
        "company_id"
      ];

    const nameInput =
      currentForm.elements[
        "company_name"
      ];

    const vatInput =
      currentForm.elements[
        "company_vat_id"
      ];


    const companyBilling =
      currentForm.querySelector(
        "[data-claywall-company-billing]"
      );

    const companyBillingCheckbox =
      currentForm.querySelector(
        "[data-claywall-use-company-seat]"
      );

    const companyBillingStatus =
      currentForm.querySelector(
        "[data-claywall-company-billing-status]"
      );


    /*
      Zapamatujeme si, zda byla
      fakturacni adresa skutecne
      prevzata ze sidla stare firmy.
    */
    const wasUsingCompanySeat =
      companyBillingCheckbox
        ?.checked === true;


    /*
      Pomocna ARES data stare firmy.
    */
    const companySeatAddress1 =
      currentForm.querySelector(
        "[data-claywall-company-seat-address1]"
      );

    const companySeatZip =
      currentForm.querySelector(
        "[data-claywall-company-seat-zip]"
      );

    const companySeatCity =
      currentForm.querySelector(
        "[data-claywall-company-seat-city]"
      );

    const companySeatRuianCode =
      currentForm.querySelector(
        "[data-claywall-company-seat-ruian-code]"
      );


    /*
      Nejprve zrusime overeni
      stare firmy.
    */
    invalidateVerifiedCompany(
      currentForm
    );


    /*
      Pokud stare sidlo firmy
      slouzilo jako fakturacni adresa,
      vycistime jej pres existujici
      change handler.
    */
    if (
      wasUsingCompanySeat &&
      companyBillingCheckbox
    ) {
      companyBillingCheckbox.checked =
        false;

      companyBillingCheckbox
        .dispatchEvent(
          new Event(
            "change",
            {
              bubbles: true
            }
          )
        );
    }


    /*
      Checkbox se po zmene ICO
      schova, dokud ARES neoveri
      novou firmu.
    */
    if (companyBillingCheckbox) {
      companyBillingCheckbox.checked =
        false;
    }

    if (companyBilling) {
      companyBilling.hidden = true;
    }


    /*
      Pokud jsme pouzivali sidlo
      stare firmy, zavreme take
      fakturacni sekci.

      Rucne zadanou fakturacni
      adresu ale nikdy nemazeme.
    */
    if (wasUsingCompanySeat) {
      const billingToggle =
        currentForm.querySelector(
          "[data-claywall-billing-toggle]"
        );

      if (billingToggle) {
        billingToggle.checked =
          false;

        billingToggle.dispatchEvent(
          new Event(
            "change",
            {
              bubbles: true
            }
          )
        );
      }
    }


    /*
      Odstranime pomocna data
      sidla stare firmy.
    */
    if (companySeatAddress1) {
      companySeatAddress1.value = "";
    }

    if (companySeatZip) {
      companySeatZip.value = "";
    }

    if (companySeatCity) {
      companySeatCity.value = "";
    }

    if (companySeatRuianCode) {
      companySeatRuianCode.value = "";
    }

    if (companyBillingStatus) {
      companyBillingStatus.textContent =
        "";
    }


    /*
      Umoznime zadat nove ICO.
    */
    if (icoInput) {
      icoInput.readOnly = false;

      icoInput.focus();
      icoInput.select();
    }

    if (nameInput) {
      nameInput.value = "";
    }

    if (vatInput) {
      vatInput.value = "";
    }
  }
);

/*
 * Pouzit sidlo firmy jako
 * fakturacni adresu.
 */
document.addEventListener(
  "change",
  event => {
    const checkbox =
      event.target.closest(
        "[data-claywall-use-company-seat]"
      );

    if (!checkbox) return;

    const currentForm =
      checkbox.closest(
        "[data-claywall-checkout-form]"
      );

    if (!currentForm) return;

    const billingToggle =
      currentForm.querySelector(
        "[data-claywall-billing-toggle]"
      );

    const billingSection =
      currentForm.querySelector(
        "[data-claywall-billing-section]"
      );

    const addressInput =
      currentForm.elements[
        "billing_address1"
      ];

    const zipInput =
      currentForm.elements[
        "billing_zip"
      ];

    const cityInput =
      currentForm.elements[
        "billing_city"
      ];

    const ruianIdInput =
      currentForm.querySelector(
        '[name="billing_ruian_id"]'
      );

    const ruianCodeInput =
      currentForm.querySelector(
        '[name="billing_ruian_code"]'
      );

    const seatAddress1 =
      currentForm.querySelector(
        "[data-claywall-company-seat-address1]"
      )?.value || "";

    const seatZip =
      currentForm.querySelector(
        "[data-claywall-company-seat-zip]"
      )?.value || "";

    const seatCity =
      currentForm.querySelector(
        "[data-claywall-company-seat-city]"
      )?.value || "";

    const seatRuianCode =
      currentForm.querySelector(
        "[data-claywall-company-seat-ruian-code]"
      )?.value || "";

    const status =
      currentForm.querySelector(
        "[data-claywall-company-billing-status]"
      );

    /*
     * ZAPNUTO
     */
    if (checkbox.checked) {
      /*
  Pokud byla predtim vybrana
  jina fakturacni adresa pres RUIAN,
  jeji object ID uz nesmi platit.

  ARES sidlo pouziva vlastni
  RUIAN kod adresniho mista.
*/
if (ruianIdInput) {
  ruianIdInput.value = "";
}

const billingVerified =
  currentForm.querySelector(
    "[data-claywall-billing-address-verified]"
  );

if (billingVerified) {
  billingVerified.hidden = true;
}

clearBillingAddressSuggestions(
  currentForm
);
      if (billingToggle) {
        billingToggle.checked = true;

        billingToggle.dispatchEvent(
          new Event(
            "change",
            {
              bubbles: true
            }
          )
        );
      }


      if (billingSection) {
        billingSection.hidden = false;
      }

      if (addressInput) {
        addressInput.value =
          seatAddress1;

        addressInput.readOnly = true;
      }

      if (zipInput) {
        zipInput.value =
          formatZip(
            seatZip
          );

        zipInput.readOnly = true;
      }

      if (cityInput) {
        cityInput.value =
          seatCity;

        cityInput.readOnly = true;
      }

      /*
       * ARES nam vraci RUIAN kod
       * adresniho mista.
       */
      if (ruianCodeInput) {
        ruianCodeInput.value =
          seatRuianCode;
      }

      if (status) {
        status.textContent =
          "Fakturační adresa byla převzata ze sídla firmy v ARES.";
      }

      return;
    }

    /*
     * VYPNUTO
     *
     * Udaje doplnene z ARES
     * vzdy odstraníme.
     */
    if (addressInput) {
      addressInput.value = "";
      addressInput.readOnly = false;
    }

    if (zipInput) {
      zipInput.value = "";
      zipInput.readOnly = false;
    }

    if (cityInput) {
      cityInput.value = "";
      cityInput.readOnly = false;
    }

    if (ruianIdInput) {
      ruianIdInput.value = "";
    }

    if (ruianCodeInput) {
      ruianCodeInput.value = "";
    }

    if (status) {
      status.textContent = "";
    }
  }
);



/*
 * Predvyplneni prijemce
 * udaji objednavajiciho.
 */
document.addEventListener(
  "click",
  event => {
    const button =
      event.target.closest(
        "[data-claywall-copy-recipient]"
      );

    if (!button) return;

    const currentForm =
      button.closest(
        "[data-claywall-checkout-form]"
      );

    if (!currentForm) return;

    const customerType =
      String(
        currentForm.elements[
          "customer_type"
        ]?.value || "person"
      );

    const recipientCompany =
      currentForm.elements[
        "recipient_company"
      ];

    const recipientFirstName =
      currentForm.elements[
        "recipient_first_name"
      ];

    const recipientLastName =
      currentForm.elements[
        "recipient_last_name"
      ];

    const recipientPhone =
      currentForm.elements[
        "recipient_phone"
      ];

    if (recipientFirstName) {
      recipientFirstName.value =
        currentForm.elements[
          "first_name"
        ]?.value || "";
    }

    if (recipientLastName) {
      recipientLastName.value =
        currentForm.elements[
          "last_name"
        ]?.value || "";
    }

    if (recipientPhone) {
      recipientPhone.value =
        currentForm.elements[
          "phone"
        ]?.value || "";
    }

    if (recipientCompany) {
      recipientCompany.value =
        customerType === "company"
          ? currentForm.elements[
              "company_name"
            ]?.value || ""
          : "";
    }
  }
);

  /*
   * Finalni checkout.
   */
  document.addEventListener(
    'submit',
    async event => {
      const currentForm =
        event.target.closest(
          '[data-claywall-checkout-form]'
        );

      if (!currentForm) return;

      event.preventDefault();

      const submit =
        currentForm.querySelector(
          '[data-claywall-submit]'
        );

      const errorElement =
        currentForm.querySelector(
          '[data-claywall-error]'
        );

      errorElement.textContent = '';

      /*
       * Vracime nativni HTML validaci.
       */
      if (!currentForm.checkValidity()) {
        currentForm.reportValidity();
        return;
      }

      const formData =
        new FormData(currentForm);

      const zip =
        normalizeZip(
          formData.get('zip')
        );

      if (!/^\d{5}$/.test(zip)) {
        errorElement.textContent =
          'Zadejte platné PSČ.';
        return;
      }

      submit.disabled = true;
      submit.textContent =
        'Připravuji objednávku…';

      try {
        /*
         * Cerstvy kosik tesne pred
         * vytvorenim Draft Orderu.
         */
        const cart =
          await loadCart();

        const billingDifferent =
  formData.get(
    'billing_different'
  ) === 'on';

const shippingAddress = {
  address1:
    String(
      formData.get(
        "address1"
      ) || ""
    ).trim(),

  address2:
    String(
      formData.get(
        "address2"
      ) || ""
    ).trim(),

  city:
    String(
      formData.get(
        "city"
      ) || ""
    ).trim(),

  zip,

  ruian_object_id:
    String(
      formData.get(
        "shipping_ruian_id"
      ) || ""
    ).trim(),

  ruian_code:
    String(
      formData.get(
        "shipping_ruian_code"
      ) || ""
    ).trim()
};

const billingZip =
  normalizeZip(
    formData.get(
      'billing_zip'
    )
  );

const billingAddress =
  billingDifferent
    ? {
        address1:
          String(
            formData.get(
              'billing_address1'
            ) || ''
          ).trim(),

        address2:
          String(
            formData.get(
              'billing_address2'
            ) || ''
          ).trim(),

        city:
          String(
            formData.get(
              'billing_city'
            ) || ''
          ).trim(),

        zip:
          billingZip,

          ruian_object_id:
  String(
    formData.get(
      "billing_ruian_id"
    ) || ""
  ).trim(),

ruian_code:
  String(
    formData.get(
      "billing_ruian_code"
    ) || ""
  ).trim()

      }
    : {
        ...shippingAddress
      };

const payload = {
  cart_token:
    cart.token,

  terms_accepted:
    formData.get(
      'terms_accepted'
    ) === 'on',

  note:
    String(
      formData.get(
        'order_note'
      ) || ''
    ).trim(),

  customer: {
  type:
    String(
      formData.get(
        "customer_type"
      ) || "person"
    ).trim(),

  first_name:
    String(
      formData.get(
        "first_name"
      ) || ""
    ).trim(),

  last_name:
    String(
      formData.get(
        "last_name"
      ) || ""
    ).trim(),

  email:
    String(
      formData.get(
        "email"
      ) || ""
    ).trim(),

  phone:
    String(
      formData.get(
        "phone"
      ) || ""
    ).trim(),

  company_name:
    String(
      formData.get(
        "company_name"
      ) || ""
    ).trim(),

  company_id:
    String(
      formData.get(
        "company_id"
      ) || ""
    )
      .replace(/\D/g, "")
      .trim(),

  company_vat_id:
    String(
      formData.get(
        "company_vat_id"
      ) || ""
    )
      .trim()
      .toUpperCase()
},
recipient: {
  company:
    String(
      formData.get(
        "recipient_company"
      ) || ""
    ).trim(),

  first_name:
    String(
      formData.get(
        "recipient_first_name"
      ) || ""
    ).trim(),

  last_name:
    String(
      formData.get(
        "recipient_last_name"
      ) || ""
    ).trim(),

  phone:
    String(
      formData.get(
        "recipient_phone"
      ) || ""
    ).trim()
},

  shipping_address:
    shippingAddress,

  billing_address:
    billingAddress,

  items:
    cart.items.map(
      item => ({
        variant_id:
          item.variant_id,

        quantity:
          item.quantity
      })
    )
};

        const shopRoot =
          window.Shopify?.routes?.root ||
          '/';

        const response =
          await fetch(
            shopRoot +
              'apps/claywall-shipping/checkout',
            {
              method: 'POST',

              headers: {
                'Content-Type':
                  'application/json'
              },

              body:
                JSON.stringify(payload)
            }
          );

        const result =
          await response.json();

        if (
          !response.ok ||
          result.status !== 'ok'
        ) {
          throw new Error(
            result.message ||
            'Pokladnu se nepodařilo připravit.'
          );
        }

        if (
          !result.draft?.invoice_url
        ) {
          throw new Error(
            'Shopify nevrátil adresu pokladny.'
          );
        }

        window.location.assign(
          result.draft.invoice_url
        );

      } catch (errorObject) {
        console.error(
          'CLAYWALL checkout:',
          errorObject
        );

        errorElement.textContent =
          errorObject.message ||
          'Pokladnu se nepodařilo připravit.';

        submit.disabled = false;
        submit.textContent =
          'Pokračovat k pokladně';
      }
    }
  );
})();